import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getCurrentUser } from './lib/appwrite';
import * as Pages from './pages/index';
import { Routes, Route } from 'react-router-dom';
import { useStateContext } from './contexts/ContextProvider';
import Loading from './pages/Loading';
import AdminLayout from './components/AdminLayout';

const ProtectedRoutes = ({ isAllowed }) => {
    return (
        <AdminLayout>
            <Routes>
                <Route path="/" element={<Pages.Dashboard />} />
                <Route path="/admin" element={<Pages.Dashboard />} />
                <Route path="/admin/account" element={<Pages.Account />} />
                <Route path='/access-control' element={<Pages.AccessControl />} />
                <Route path="/admin/dashboard" element={<Pages.Dashboard />} />
                <Route path="/admin/testimonials" element={<Pages.Testimonials />} />
                <Route path="/admin/messages" element={<Pages.Messages />} />
                <Route path="/admin/photos" element={<Pages.Photos />} />
                <Route path="/admin/users" element={<Pages.Users />} />
                <Route path="/admin/customers" element={<Pages.Customers />} />
                <Route path="/admin/calendar" element={<Pages.Calendar />} />
            </Routes>
        </AdminLayout>
    );
};

const ProtectedContent = () => {
    const [isAllowed, setIsAllowed] = useState(false);
    const [loading, setLoading] = useState(true);
    const { account, isLoggedIn } = useStateContext();

    useEffect(() => {
        const checkAccess = async () => {
            // Allow access if user is logged in and is admin
            // For now, we'll allow all logged-in users (can be restricted later)
            if (isLoggedIn && account) {
                setIsAllowed(true);
            } else {
                setIsAllowed(false);
            }
            setLoading(false);
        };

        checkAccess();
    }, [isLoggedIn, account]);

    if (loading) {
        return <Loading />;
    }

    if (!isAllowed) {
        return (
            <div className="flex items-center justify-center h-screen">
                <div className="text-center">
                    <h1 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">Access Denied</h1>
                    <p className="text-gray-600 dark:text-gray-400">You need to be logged in to access this page.</p>
                </div>
            </div>
        );
    }

    return <ProtectedRoutes />;
};

export default ProtectedContent;

